module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-button', {
    staticClass: "md-icon-button md-raised",
    attrs: {
      "disabled": !_vm.canPageDown
    },
    on: {
      "click": _vm.pageDown
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page),
      expression: "page"
    }],
    staticClass: "current-page-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page = $event.target.value
      }
    }
  }), _vm._v("\r\n        /" + _vm._s(_vm.totalPages) + "\r\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-raised",
    attrs: {
      "disabled": !_vm.canPageUp
    },
    on: {
      "click": _vm.pageUp
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cffacc00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/pagination.vue
// module id = 681
// module chunks = 2